export const typeRelateDetail = {
    "L": "Длина",
    "W": "Высота",
    "H": "Толщина"
}